import { GoogleLogin } from "react-google-login";
import { connect } from 'react-redux';
import { login,setLoggedIn } from '../actions/login/authssoActions';
import { OrderFlow } from "../App";
import googleImage from './g.jpg';
// const clientId="818058364680-0h15mo0i9aprr7g47hriu8puib7eb0aa.apps.googleusercontent.com";
const clientId="818058364680-6d3u6vo52bkqb50r6bg6ph31tis44ibg.apps.googleusercontent.com";

const Login = ({ login,onClosePopup,isLoggedIn }) => {
  console.log(googleImage)
  const {oneTabShow, setOneTabShow}=OrderFlow();
  const handleLoginWithGoogle = () => {
    const currentUrl = window.location.href;
    const updatedUrl = `${currentUrl}${currentUrl.includes('?') ? '&' : '?'}google_login=1`;
    window.location.href = `http://sso.fusionepos.co.uk/google_redirect.php?page=${encodeURIComponent(updatedUrl)}`;
  };
      

    const onSuccess= (res) => {
        onClosePopup();
        setOneTabShow(false);
        const postData = {
                verfication_code: res.googleId,
                email: res.profileObj.email,
                login_type: 1,
                first_name:res.profileObj.givenName,
                last_name:res.profileObj.familyName
            };  
        login(JSON.stringify(postData));
    }

    const onFailure= (res) => {
        console.log("Login Failed! res:",res);
    }

    return (
        // <div id="signInButton">
        <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0px 16px',
          borderRadius: '8px',
          border: '1px solid #E9E9E9',
          fontSize: '17px',
          fontFamily: 'SegoeUI, sans-serif',
          height: '45px',
          fontWeight: 500,
          width: '90%',
          textAlign: 'center',
          gap: '10px',
          margin: '0px auto',
          // margin: '16px auto',
          backgroundColor: '#ffffff',
          color: '#000000',
          cursor: 'pointer',
        }}
        onClick={handleLoginWithGoogle}
        className="google_btn"
        data-Fus="fus-test-Googleloginbtn"
      >
        <img src={googleImage} alt="Google" style={{ width: '20px', height: '20px', objectFit: 'contain',marginLeft:"10px" }} />
        <span>Continue with Google</span>
      </div>
             
    )
}

const mapStateToProps = (state) => {
    return {
      isLoggedIn: state.userdata.isLoggedIn,
      userData: state.userdata.userData,
    };
  };
  
  const mapDispatchToProps = {
    login,
    setLoggedIn,
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(Login);